import Box from "@mui/material/Box";
import { cleanProps } from "../internal/cleanProps";
import type { FieldRowProps } from "../types";

/**
 * ADR-20261102-h2fd: two form fields side by side, as H2 screen 3 sets the phone and email
 * fields -- two equal columns 18px apart from 600px, one column below.
 */
export function FieldRow({ children, testId }: Readonly<FieldRowProps>) {
  return (
    <Box
      {...cleanProps({ "data-testid": testId })}
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
        columnGap: "18px",
        rowGap: "18px",
      }}
    >
      {children}
    </Box>
  );
}
